import { Heading, Paragraph } from "../../../atoms";
import { Box } from "../../../cores";
import { useViewContext } from "../../../hooks";

interface IBodyTypeDescription {
  descriptionTitle: string;
  descriptionText: Array<string>;
}

const BodyTypeDescription = ({
  descriptionTitle,
  descriptionText,
}: IBodyTypeDescription) => {
  const { isMobile } = useViewContext();
  return (
    <Box sx={{ width: "100%" }}>
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {descriptionTitle}
      </Heading>
      <ul>
        {descriptionText.map((bodyType) => {
          const lastIndexOf = bodyType.lastIndexOf(">");
          const bodyTypeTitle = bodyType.slice(
            bodyType.indexOf("<") + 1,
            lastIndexOf
          );
          const bodyTypeDescription = bodyType.substring(lastIndexOf + 1);
          return lastIndexOf > 0 ? (
            <li key={bodyType}>
              <Paragraph>
                <b>{bodyTypeTitle}</b> - {bodyTypeDescription}
              </Paragraph>
            </li>
          ) : null;
        })}
      </ul>
    </Box>
  );
};

export default BodyTypeDescription;
